import { IconProps } from 'src/utils/icon';

const OpenIcon: React.FC<IconProps> = ({ size = 1, fill = '#2c2a29' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    viewBox="0 0 21 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.6789 5.4375H17.0241V3.84375C17.0241 2.96387 16.2814 2.25 15.366 2.25H9.83866L7.62774 0.125H2.10045C1.18499 0.125 0.442261 0.838867 0.442261 1.71875V11.2812C0.442261 12.1611 1.18499 12.875 2.10045 12.875H15.9187C16.4887 12.875 17.0207 12.5928 17.3247 12.1246L20.0849 7.87461C20.7758 6.81543 19.9812 5.4375 18.6789 5.4375ZM2.10045 1.91797C2.10045 1.8084 2.19372 1.71875 2.30772 1.71875H6.94028L9.1512 3.84375H15.1587C15.2727 3.84375 15.366 3.9334 15.366 4.04297V5.4375H5.69319C5.11282 5.4375 4.57391 5.72969 4.27337 6.20781L2.10045 9.66758V1.91797ZM15.9187 11.2812H2.92954L5.59646 7.03125H18.6823L15.9187 11.2812Z"
      fill={fill}
    />
  </svg>
);

export default OpenIcon;
